import AdminConsoleDeleteDialog from "../../../base/AdminConsoleDeleteDialog";
import { adminConsoleSection } from "../../../../../../../../utils/constants";
import { deleteAcSection } from "../../../../../../../../axios/api/services";

const AdminConsoleSectionDeleteDialog = () => {
  return (
    <AdminConsoleDeleteDialog
      section={adminConsoleSection.section}
      title={"t.ac.section.delete.dialog"}
      message={"m.delete.ac.section.warning.message"}
      serviceFn={deleteAcSection}
    />
  );
};
export default AdminConsoleSectionDeleteDialog;
